export const icons = {
  width: 24,
  height: 24,
  display: 'block',
};
export const iconSearch = {
  width: 18,
  height: 18,
  display: 'block',
};
export const triangle = {
  width: 15,
  height: 15,
  display: 'block',
};
export const headerTitleStyle = {
  padding: '8px 16px',
  fontWeight: 'bold',
  fontSize: 14,
  color: '#6C637B',
};
